import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wsg-loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.css']
})
export class LoadingPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
